import useOutsideClick from "hooks/click-outside-hook";
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Controller, useForm } from "react-hook-form";
import { AiOutlineClose } from "react-icons/ai";
import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import { useNavigate } from "react-router-dom";
import useUtils from "hooks/useUtils";
import { useSelector } from "react-redux";
import usePolicies from "../useHooks";
type FormValues = {
  content: string;
};

const EditPolicy: React.FC = () => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm<FormValues>();
  const navigate = useNavigate();

  const { getQueryParams } = useUtils();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const params = getQueryParams();

  const { getPolicyByID, editPolicyByID } = usePolicies();
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    const fetchPolicy = async () => {
      await getPolicyByID(setData, { id: params?.id });
    };

    if (params.id) {
      fetchPolicy();
    }
  }, [params?.id]);

  useEffect(() => {
    if (data?.[0]?.content) {
      reset({ content: data[0].content });
    }
  }, [data, reset]);

  console.log(params?.id, "params?.id");

  const handleBack = () => {
    navigate(-1);
  };

  console.log(data);

  const onSubmit = async (formData: FormValues) => {
    await editPolicyByID(params?.id, formData);
  };
  return (
    <div>
      <h1 className="text-base text-primaryText font-bold mb-6 flex items-center gap-3">
        <span
          onClick={handleBack}
          className="bg-transparentBlueBg w-[44px] h-[44px] rounded-full flex items-center justify-center cursor-pointer"
        >
          <ArrowBackIcon />
        </span>
        Edit
      </h1>

      <div className="w-full bg-white p-4 rounded-[8px]">

        <h1 className="text-lg text-primaryText font-bold"> {data?.[0]?.heading || "N/A"}</h1>


        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex flex-col gap-3 mt-3"
        >
          <div>
            <label>Policy Description</label>
            <Controller
              name="content"
              control={control}
              rules={{ required: "Description is required" }}
              render={({ field }) => (
                <ReactQuill
                  theme="snow"
                  value={field.value || ""}
                  onChange={field.onChange}
                  style={{ minHeight: "150px" }}
                />
              )}
            />
            {errors.content && <p>{errors.content.message}</p>}
          </div>

          {/* Submit Button */}
          <div className="flex justify-start mt-5">
            <button
              type="submit"
              className="w-[125px] h-[45px] text-xl font-semibold text-white bg-darkTealBlue rounded-[8px]"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPolicy;
